module.exports = __webpack_public_path__ + "static/media/logo.76c52d50.svg";